var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "integralUser seller-style" },
    [
      _c("h2", { staticClass: "f18 fb normal gray_2" }, [_vm._v("凭证审核")]),
      _c("div", { staticClass: "box30" }),
      _c(
        "div",
        { staticClass: "flex items-center mar15-b" },
        [
          _c("div", { staticClass: "lable" }, [_vm._v("采购单号：")]),
          _c("el-input", {
            staticClass: "w200 mar20_r",
            attrs: { placeholder: "请输入采购单号" },
            model: {
              value: _vm.search.orderId,
              callback: function($$v) {
                _vm.$set(
                  _vm.search,
                  "orderId",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "search.orderId"
            }
          }),
          _c("div", { staticClass: "lable" }, [_vm._v("收货人：")]),
          _c("el-input", {
            staticClass: "w200 mar20_r",
            attrs: { placeholder: "请输入收货人" },
            model: {
              value: _vm.search.linkman,
              callback: function($$v) {
                _vm.$set(
                  _vm.search,
                  "linkman",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "search.linkman"
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "flex items-center justify-between mar20-b" }, [
        _c(
          "div",
          { staticClass: "flex items-center" },
          [
            _c("div", { staticClass: "lable" }, [_vm._v("审核状态：")]),
            _c(
              "el-select",
              {
                staticClass: "w240",
                attrs: { placeholder: "请选择审核状态" },
                model: {
                  value: _vm.search.approvalStatus,
                  callback: function($$v) {
                    _vm.$set(_vm.search, "approvalStatus", $$v)
                  },
                  expression: "search.approvalStatus"
                }
              },
              _vm._l(_vm.statusList, function(item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.name, value: item.id }
                })
              }),
              1
            ),
            _c("div", { staticClass: "lable" }, [_vm._v("日期：")]),
            _c("el-date-picker", {
              staticClass: "mar20_r",
              attrs: {
                type: "datetimerange",
                "value-format": "yyyy-MM-dd HH:mm:ss",
                "range-separator": "-",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束日期"
              },
              model: {
                value: _vm.timeList,
                callback: function($$v) {
                  _vm.timeList = $$v
                },
                expression: "timeList"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.searchList } },
              [_vm._v("查询")]
            ),
            _c("el-button", { on: { click: _vm.resetList } }, [_vm._v("重置")])
          ],
          1
        )
      ]),
      _vm._m(0),
      _vm.list.length
        ? [
            _vm._l(_vm.list, function(item) {
              return _c("div", { key: item.id, staticClass: "bor-gray" }, [
                _c("div", { staticClass: "bg-f5 h30 flex items-center" }, [
                  _c("span", { staticClass: "pad10-lr" }, [
                    _vm._v(_vm._s(item.orderTime))
                  ]),
                  _c("span", { staticClass: "pad10-lr" }, [
                    _vm._v("订单编号：" + _vm._s(item.orderId))
                  ]),
                  _c("span", { staticClass: "pad10-lr" }, [
                    _vm._v("收货人：" + _vm._s(item.linkman))
                  ])
                ]),
                _c("div", { staticClass: "flex pad10-tb" }, [
                  _c(
                    "div",
                    { staticClass: "flex-auto" },
                    _vm._l(item.orderGoodsList, function(good, index) {
                      return _c("div", { key: index, staticClass: "flex" }, [
                        _c("div", { staticClass: "flex flex-auto pad20-l" }, [
                          _c("img", {
                            staticClass: "good-img",
                            attrs: { src: good.goodsPic }
                          }),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-column justify-between pad10-l"
                            },
                            [
                              _c("div", [_vm._v(_vm._s(good.goodsName))]),
                              _c("div", [
                                _vm._v("规格：" + _vm._s(good.goodsSpec))
                              ])
                            ]
                          )
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "w60 flex items-center justify-center"
                          },
                          [_vm._v(_vm._s(good.goodsQuantity))]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "w80 flex items-center justify-center"
                          },
                          [_vm._v("￥" + _vm._s(good.sellFactPrice))]
                        )
                      ])
                    }),
                    0
                  ),
                  _c(
                    "div",
                    { staticClass: "w80 flex items-center justify-center" },
                    [_vm._v("￥" + _vm._s(item.fMoney))]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "pad10-l pad5-r w200 flex flex-wrap items-center"
                    },
                    _vm._l(item.sellerVoucherImgUrl, function(item, index) {
                      return _c("img", {
                        key: index,
                        staticClass: "img",
                        attrs: { src: item }
                      })
                    }),
                    0
                  ),
                  _c(
                    "div",
                    { staticClass: "w80 flex items-center justify-center" },
                    [
                      item.approvalStatus === 0
                        ? _c("span", { staticClass: "blue" }, [
                            _vm._v("未审核")
                          ])
                        : _vm._e(),
                      item.approvalStatus === 1
                        ? _c("span", { staticClass: "green" }, [
                            _vm._v("已通过")
                          ])
                        : _vm._e(),
                      item.approvalStatus === 2
                        ? _c("span", { staticClass: "red" }, [_vm._v("已驳回")])
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "w210 flex items-center justify-center" },
                    [
                      item.approvalStatus === 0
                        ? [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "mini" },
                                on: {
                                  click: function($event) {
                                    return _vm.audit(item.id)
                                  }
                                }
                              },
                              [_vm._v("通过")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "danger", size: "mini" },
                                on: {
                                  click: function($event) {
                                    return _vm.reject(item.id)
                                  }
                                }
                              },
                              [_vm._v("驳回")]
                            )
                          ]
                        : _vm._e(),
                      item.approvalStatus === 2
                        ? [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "danger", size: "mini" },
                                on: {
                                  click: function($event) {
                                    return _vm.rejectRause(item.rejectReason)
                                  }
                                }
                              },
                              [_vm._v("驳回原因")]
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ])
              ])
            }),
            _c(
              "div",
              { staticClass: "flex items-center mar40-t" },
              [
                _c("div", { staticClass: "gray9 flex-auto" }, [
                  _vm._v(
                    "共 " +
                      _vm._s(_vm.pageTotal) +
                      " 条记录 第 " +
                      _vm._s(_vm.pageNum) +
                      " / " +
                      _vm._s(_vm.totalPage) +
                      " 页"
                  )
                ]),
                _c("el-pagination", {
                  attrs: {
                    layout: "prev, pager, next, sizes, jumper",
                    background: "",
                    "hide-on-single-page": "",
                    "page-size": _vm.pageSize,
                    "page-count": _vm.totalPage,
                    "current-page": _vm.pageNum,
                    "page-sizes": [30, 50, 100]
                  },
                  on: {
                    "update:pageSize": function($event) {
                      _vm.pageSize = $event
                    },
                    "update:page-size": function($event) {
                      _vm.pageSize = $event
                    },
                    "update:currentPage": function($event) {
                      _vm.pageNum = $event
                    },
                    "update:current-page": function($event) {
                      _vm.pageNum = $event
                    },
                    "size-change": _vm.sizeChange,
                    "current-change": _vm.currentChange
                  }
                })
              ],
              1
            )
          ]
        : _c(
            "div",
            {
              staticClass: "pad30-tb bor-gray flex items-center justify-center"
            },
            [_vm._v("暂无订单")]
          ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "确认自提",
            visible: _vm.dialogVisible,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "mar10-b" },
                [
                  _c("span", [_vm._v("请输入提货码：")]),
                  _c("el-input", {
                    staticClass: "w240",
                    attrs: { placeholder: "请输入提货码" },
                    model: {
                      value: _vm.input,
                      callback: function($$v) {
                        _vm.input = $$v
                      },
                      expression: "input"
                    }
                  })
                ],
                1
              ),
              _c("div"),
              _c("div", { staticClass: "f12 red mar10-b" }, [
                _vm._v("提货码可向提货人索要，同时请验证司机车牌和身份")
              ]),
              _c("div", { staticClass: "mar10-b" }, [
                _vm._v("卖家上传凭证（仅支持图片，最多5张）")
              ]),
              _c(
                "el-upload",
                {
                  staticClass: "mar10-b",
                  attrs: {
                    action: _vm.env.VUE_APP_fileserver + "persistentUpload",
                    limit: 5,
                    "file-list": _vm.photoList,
                    "list-type": "picture-card",
                    "on-success": _vm.uploadSuccess,
                    "before-upload": _vm.uploadBefore,
                    "on-remove": _vm.uploadRemove,
                    "on-exceed": _vm.uploadExceed
                  }
                },
                [_c("i", { staticClass: "el-icon-plus avatar-uploader-icon" })]
              ),
              _c(
                "div",
                { staticClass: "flex items-center mar10-b" },
                [
                  _c("span", [_vm._v("提货单号：")]),
                  _c("el-input", {
                    staticClass: "w240",
                    attrs: { placeholder: "请输入提货单号" },
                    model: {
                      value: _vm.input,
                      callback: function($$v) {
                        _vm.input = $$v
                      },
                      expression: "input"
                    }
                  })
                ],
                1
              ),
              _c("div", { staticClass: "mar10-b" }, [_vm._v("温馨提示：")]),
              _c("div", { staticClass: "mar10-b" }, [
                _vm._v(
                  "为避免交易风险，确认提货前请上传提货单等交货凭证并填写提货人提供的提货码后确认自提"
                )
              ]),
              _c("div", [
                _vm._v(
                  "\n        点击“确认自提”，即视为您按照买家实际下单的具体信息（包括但不限于货品的品类、数量、质量标准、自提车辆信息等）交付，请勿将货品转让给其他人，\n        且不得进行套现等不正当的行为。请您务必确保操作准确无误!否则，由此产生的风险和责任将由您自行承担。\n      "
                )
              ])
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.consImg } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex items-center text-center bg-f5 h40 mar10-b" },
      [
        _c("div", { staticClass: "flex-auto" }, [_vm._v("货品")]),
        _c("div", { staticClass: "w60" }, [_vm._v("数量")]),
        _c("div", { staticClass: "w80" }, [_vm._v("价格")]),
        _c("div", { staticClass: "w80" }, [_vm._v("合计金额")]),
        _c("div", { staticClass: "w200" }, [_vm._v("提货凭证")]),
        _c("div", { staticClass: "w80" }, [_vm._v("状态")]),
        _c("div", { staticClass: "w210" }, [_vm._v("操作")])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }